import styled from 'styled-components/macro';

/**
 * Flex column
 */
const Column = styled('div')`
  position: relative;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  box-sizing: border-box;
`;

export default Column;
